'use strict';

function _ContentCenterController() {
  this.id = null;
  this.node = null;
  this.extends = [_AccountController];

  this._ACTIONS = {
    CONTENT_CENTER_INDEX: 'account.index_content_slides',
    CONTENT_CENTER_BANNER_DISMISS: 'account.dismiss_content_center'
  };

  this._banners = [];
  this._bannerContentLoad = null;
  this._bannersLoad = null;
  this._bannerContentLoad = null;
  this._waitingCallbacks = [];

  this.init = function () {
    this._super();

    // Create content center model if it doesn't exist
    if (!this.presenter.models.content_center) {
      this.presenter.createModel('content_center');
    }

    // Retrieve banners
    this._retrieveBanners();

    // Retrieve banner content
    this._retrieveBannerContent();
  };

  this.initAllReady = function () {
    this._super();
    if (!this.validated) return;
  };

  /*
    Callback returns:
      data:
      {
        banners: ContentCenterBanner objects (Array)
        OR
        errors: [{
          code: 404,
          key: 'no_action_error'
        }]
      }
      response: HTTP code (Integer),
  */
  this.retrieveBanners = function (callback) {
    if (callback) this._waitingCallbacks.push(callback);
    $.when(this._bannersLoad, this._bannerContentLoad).done(this._onAllDataLoaded.bind(this));
    $.when(this._bannersLoad, this._bannerContentLoad).fail(this._dataLoadError.bind(this));
  };

  /*
    Persists the dismissal of the banner.
     Arguments:
      bannerId (ContentCenterBanner id): Banner to be dismissed
      callback
          returns
          data:
          {
            banners: ContentCenterBanner objects (Array)
            OR
            errors: [{
              code: 404,
              key: 'no_action_error'
            }]
          }
          response: HTTP code (Integer)
  */
  this.dismissBanner = function (bannerId, callback) {
    var bannerToBeDismissed = this._banners.filter(function (banner) {
      return banner.getId() === bannerId;
    });
    var dismissBannerIndex = this.presenter.models.content_center.banners.content_slides.findIndex(function (slide) {
      return slide.id === bannerId;
    });
    var dismissBannerAction = 'content_center.banners.content_slides[' + dismissBannerIndex + '].dismiss_content_slide';
    if (bannerToBeDismissed[0] && bannerToBeDismissed[0].isDismissible()) {
      this.presenter.performAction(dismissBannerAction, null, callback);
    } else if (callback) {
      callback({
        errors: [{
          code: 404,
          key: 'no_action_error'
        }]
      }, 404);
    }
  };

  this._retrieveBanners = function () {
    this._bannersLoad = $.Deferred();

    // Retrieve banners
    if (!this.presenter.models.content_center.banners) {
      // No model created yet
      this.presenter.createModel('content_center.banners');
      this.presenter.setModelProperty('content_center.banners.loading', this._bannersLoad);
      this.presenter.performAction(this._ACTIONS.CONTENT_CENTER_INDEX, null, this._onRetrieveBanners.bind(this));
    } else if (this.presenter.getModelProperty('content_center.banners.loading')) {
      // Data request in process
      this._bannersLoad = this.presenter.getModelProperty('content_center.banners.loading');
    } else {
      // Data already exists
      this._bannersLoad.resolve();
    }
  };

  this._onRetrieveBanners = function (data, responseCode) {
    if (responseCode === 200) {
      this.presenter.removeModelProperty('content_center.banners.loading');
      this.presenter.updateModel('content_center.banners', data);
      this._bannersLoad.resolve();
    } else {
      this._bannersLoad.reject({ data: data, response: responseCode });
    }
  };

  this._retrieveBannerContent = function () {
    this._bannerContentLoad = $.Deferred();

    // Retrieve contentful banner content
    if (!this.presenter.models.content_center.banner_content) {
      // No model created yet
      this.presenter.createModel('content_center.banner_content');
      this.presenter.setModelProperty('content_center.banner_content.loading', this._bannerContentLoad);
      var contentful = new Contentful(_ContentfulConfiguration, $.extend({}, ContentfulSpaceParams, {
        space_id: ContentfulAppSpaceParams.space_id,
        accessToken: ContentfulAppSpaceParams.accessToken,
        verboseLevel: 2
      }));
      contentful.getResource('ENTRIES_FROM_MODEL', {
        model_id: 'contentCenterSlide'
      }, this._onRetrieveBannerContent.bind(this));
    } else if (this.presenter.getModelProperty('content_center.banner_content.loading')) {
      // Data request in process
      this._bannerContentLoad = this.presenter.getModelProperty('content_center.banner_content.loading');
    } else {
      // Data already exists
      this._bannerContentLoad.resolve();
    }
  };

  this._onRetrieveBannerContent = function (data, responseCode) {
    // No response code if successful
    if (!responseCode) {
      this.presenter.removeModelProperty('content_center.banners.loading');
      this.presenter.updateModel('content_center.banner_content', data);
      this._bannerContentLoad.resolve();
    } else {
      this._bannerContentLoad.reject({ data: data, response: responseCode });
    }
  };

  this._onAllDataLoaded = function () {
    var _this = this;

    // Build ContentCenterBanner
    var bannersList = this.presenter.getModelProperty('content_center.banners.content_slides');
    var contentCenterBanners = [];
    if (bannersList && bannersList.length > 0) {
      for (var i = 0; i < bannersList.length; i++) {
        contentCenterBanners[i] = new ContentCenterBanner(this.presenter, this.presenter.models.content_center.banners.content_slides[i]);
      }
    } else {
      // Default slide
      this.presenter.setModelProperty('content_center.banners.content_slides', [
      // TEST DATA
      // {
      //   content_type_id: 'content-center',
      //   content_values: {amt: '123'},
      //   contentful_key: 'level-up-offer-slide',
      //   dismissible: true,
      //   id: 1,
      //   sort_order: 1000
      // },
      // {
      //   content_type_id: 'content-center',
      //   content_values: {amt: '999'},
      //   contentful_key: 'credit-seeker-pre-approval-slide',
      //   dismissible: true,
      //   id: 2,
      //   sort_order: 1000
      // },
      {
        content_type_id: 'content-center',
        content_values: {},
        contentful_key: 'default-slide',
        dismissible: false,
        id: 1,
        sort_order: 1000
      }]);

      this.presenter.models.content_center.banners.content_slides.forEach(function (slide, i) {
        contentCenterBanners[i] = new ContentCenterBanner(_this.presenter, slide);
      });
    }

    for (var _i = 0; _i < this._waitingCallbacks.length; _i++) {
      this._waitingCallbacks[_i]({ banners: contentCenterBanners }, 200);
    }
  };

  this._dataLoadError = function (bannersLoad, bannerContentLoad) {
    if (this._bannersLoad.state() === 'rejected') {
      // Can't load SOA, display default
      if (this._bannerContentLoad.state() === 'resolved') {
        this._onAllDataLoaded();
      } else {
        $.when(this._bannerContentLoad).done(this._onAllDataLoaded.bind(this));
      }
    } else {
      // Can't load banner content, callback error
      for (var i = 0; i < this._waitingCallbacks.length; i++) {
        this._waitingCallbacks[i]({
          errors: [{
            code: 502,
            key: 'contentful_unavailable'
          }]
        }, 502);
      }
    }
  };

  this.destroy = function () {
    this._super();
    this._waitingCallbacks = [];
  };
}